import { Injectable } from '@angular/core';
import { CFHttpClient } from '@mem-shared/cf-http-client';
import { Observable } from 'rxjs/Observable';
import { LanguageLink } from './language-link.model';
import { environment } from 'environments/environment';

const footerLanguageUrl = environment.servicePublicURLs.footerLanguageURL; // '/mas/pub/getTeamsiteForeignLanguageLinks.json';
const activityFeedUrl = environment.serviceSecuredURLs.getActivityFeedURL;

@Injectable()
export class FooterService {
  constructor(private http: CFHttpClient) { }

  getFooterLanguageLinks(): Observable<LanguageLink[]> {
    const footUrl = window.location.origin + footerLanguageUrl;
    return this.http.get(footUrl).map(this.getLanguageArray);
  }

  getActivityFeed(userId: string) {
    const inputParams = {
      'userId': userId
    };
    return this.http.get(activityFeedUrl, inputParams);
  }

  /**
   * Get current app version from assets
   */
  getAppVersion() {
    //if(environment.name === 'stg'){
    return this.http.get(environment.applicationRoot + '/assets/version.json');
    //}else{
    //return this.http.get('/mosweb/assets/version.json');
    //}

  }

  /**
   * Converts the key/value pairs to
   * an array.
   */
  private getLanguageArray({ contentForeignLanguagePageLinks }) {
    const languageLinks = contentForeignLanguagePageLinks;
    const languageLinksArray = [];

    for (const link in languageLinks) {
      if (languageLinks.hasOwnProperty(link)) {
        const currentLink = languageLinks[link];
        currentLink.url = encodeURIComponent(currentLink.url);
        languageLinksArray.push(currentLink);
      }
    }

    return languageLinksArray;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/footer/footer.service.ts